import { User } from '@arpeggi/shared'
import { log } from '../utils/logger'
import { WalletProviderType } from './wagmi/connectors'

export const segmentIdentifyUser = (userData: User & { email?: string }) => {
  log.info({ category: 'THIRD_PARTY', data: userData }, 'segmentIdentifyUser')

  window.analytics.identify(userData.walletAddress, {
    name: userData.displayName,
    email: userData.email,
    source: window.location.pathname
  })
}

export const segmentSignUp = (
  walletAddress: string,
  email: string,
  displayName: string,
  walletProvider: string
) => {
  window.analytics.track('Account Created', {
    name: displayName,
    email: email,
    wallet: walletAddress,
    provider: walletProvider,
    source: window.location.pathname
  })
  segmentIdentifyWithEmail(walletAddress, email, displayName, walletProvider)
}

export const segmentIdentifyWithEmail = (
  walletAddress: string,
  email: string,
  displayName: string,
  walletProvider: string
) => {
  window.analytics.identify(walletAddress, {
    name: displayName,
    email: email,
    provider: walletProvider,
    source: window.location.pathname
  })
}

export const segmentWalletProvider = (walletProvider: WalletProviderType) => {
  window.analytics.track('Button Clicked', {
    button: 'Wallet Provider',
    provider: walletProvider,
    source: window.location.pathname
  })
}

export const segmentButtonClick = (button: string) => {
  window.analytics.track('Button Clicked', {
    button: button,
    source: window.location.pathname
  })
}

export const segmentCarouselButton = (button: string) => {
  window.analytics.track('Button Clicked', {
    button: button,
    location: 'homepage carousel',
    source: window.location.pathname
  })
}
